import { render, staticRenderFns } from "./AcoesDevolverItemLote.vue?vue&type=template&id=cbfe65a0&scoped=true"
import script from "./AcoesDevolverItemLote.vue?vue&type=script&lang=js"
export * from "./AcoesDevolverItemLote.vue?vue&type=script&lang=js"
import style0 from "./AcoesDevolverItemLote.vue?vue&type=style&index=0&id=cbfe65a0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfe65a0",
  null
  
)

export default component.exports